import clsx from 'clsx'
import React, { useRef, useState } from 'react';
import { FieldProps, getIn} from 'formik';
import {FormFileUploadProps} from './_types'

const RawFileUpload: React.FC<FormFileUploadProps & FieldProps> = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, setFieldValue, setFieldTouched, isSubmitting },
  ...props
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [fileName, setFileName] = useState<string | null>(null)

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];

    if (file) {
      setFileName(file.name);
      setFieldValue(field.name, file); // Use form.setFieldValue to update the Formik state
      props?.onChange && props.onChange(e)
    }
  }

  return (
    <input
      type="file"
      id={field.name}
      name={field.name}
      ref={fileInputRef}
      disabled={props.disabled || isSubmitting}
      accept={props?.accept}
      onChange={handleFileChange}
      onBlur={() => setFieldTouched(field.name, true)} // Use form.setFieldTouched to update the touched state
      style={props.style}
      className={clsx(
        'form-control mb-2',
        props.className ? props.className : undefined,
        {
          'is-invalid': getIn(touched, field.name) && getIn(errors, field.name),
          'is-valid': getIn(touched, field.name) && !getIn(errors, field.name)
        }
      )}
    />
  )
}

const FileUpload: React.FC<FormFileUploadProps & FieldProps> = ({field, form, ...props}) => {
  return (
    <div className='fv-row mb-7'>
      {props.label && (
        <label className={clsx(
          'fw-bold fs-6 mb-2',
          {required: props.required}
        )}>
          {props.label}
        </label>
      )}

      <RawFileUpload
        field={field}
        form={form}
        {...props}
      />

      {getIn(form.touched, field.name) &&
        getIn(form.errors, field.name) && (
          <div className='fv-plugins-message-container text-start'>
            <div className='fv-help-block'>
              <span role='alert'>{getIn(form.errors, field.name) as string}</span>
            </div>
          </div>
        )
      }
    </div>
  );
};

export {FileUpload, RawFileUpload}
